import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 50c8.203 0 15.483-3.95 20.041-10.053H4.959C9.517 46.049 16.797 50 25 50ZM50 25C50 11.193 38.806 0 25 0S0 11.193 0 25c0 2.956.515 5.792 1.457 8.424h47.086A24.954 24.954 0 0 0 49.999 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m17.112 16.033 1.349 4.151h4.365l-3.532 2.567 1.35 4.151-3.532-2.566-3.532 2.566 1.349-4.151-3.532-2.567h4.366l1.349-4.151ZM9.615 11.685l.81 2.491h2.618l-2.118 1.54.809 2.49-2.12-1.539-2.118 1.54.81-2.491-2.12-1.54h2.62l.809-2.49Z"
}));
FlagCW.displayName = 'FlagCW';
export default withFlagWrapper(FlagCW);
//# sourceMappingURL=index.js.map